import { css } from 'styled-components'

export const HEADER_LABEL = css`
  font-size: 13px;
  line-height: 22px;
  margin: 5px 0px 10px;
  color: rgb(79, 79, 79);
`
